import {
  isValidDocumentURL,
  isValidEmail,
  isValidPhoneNumber,
} from "./validators";

export const doNotImport: string = "Do not import";
export const nameDataType: string = "name";
export const textDataType: string = "text";
export const emailDataType: string = "email";
export const phoneDataType: string = "phone";
export const documentUrlDataType: string = "documentUrl";

export interface SpreadSheetUploadStep {
  number: number;
  label: string;
}

export interface Column {
  label: string;
  value: string;
  icon: string;
  type?: string;
  isRequired?: boolean;
}

export const spreadSheetUploadSteps: SpreadSheetUploadStep[] = [
  { number: 1, label: "Upload file" },
  { number: 2, label: "Match columns" },
  { number: 3, label: "Validate data" },
];

export const inventoryColumns: Column[] = [
  { label: doNotImport, value: doNotImport, icon: "" },
  {
    label: "Item Code",
    value: "item_code",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Description",
    value: "description",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Unit Weight(KG)",
    value: "unit_weight",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Length",
    value: "length",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Unit Value",
    value: "value",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Hire Rate / Week",
    value: "hire_rate_per_week",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Available Quantity",
    value: "available_quantity",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Rented Quantity",
    value: "rented_quantity",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Reserved Quantity",
    value: "reserved_quantity",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Damaged Quantity",
    value: "damaged_quantity",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Lost Quantity",
    value: "lost_quantity",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
  {
    label: "Sold Quantity",
    value: "sold_quantity",
    icon: "",
    type: textDataType,
    isRequired: false,
  },
];

export function validateSpreadSheetCell(
  dataType: string,
  value: any,
  isRequired: boolean
): boolean {
  if (!isRequired) {
    return true;
  }
  if (value === undefined) {
    return value !== undefined;
  }
  if (dataType === nameDataType) {
    const splittedValue = value.toString().trim().split(" ");
    return splittedValue.length === 2;
  }
  if (dataType === emailDataType) {
    return isValidEmail(value);
  }
  if (dataType === phoneDataType) {
    return isValidPhoneNumber(value);
  }
  if (dataType === documentUrlDataType) {
    return isValidDocumentURL(value);
  }
  if (dataType === textDataType) {
    return !(value?.length < 1 || value?.length > 100);
  }
  return true;
}

/**
 * Returns true if the row should be kept: keep when at least one column has a value.
 * Rows with every cell empty/undefined are filtered out.
 */
export function shouldKeepRow<T extends Record<string, any>>(
  row: T,
  columns: string[]
): boolean {
  return columns.some((col) => {
    const v = row[col];
    return v !== undefined && v !== null && String(v).trim() !== "";
  });
}
